var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningAmber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7218 15.4983H1.27765C0.979931 15.4983 0.704832 15.3395 0.555976 15.0817C0.407121 14.8238 0.407123 14.5062 0.555981 14.2483L8.27765 0.915001C8.42662 0.657594 8.70149 0.499092 8.9989 0.499092C9.29631 0.499092 9.57117 0.657594 9.72015 0.915001L17.4418 14.2483C17.5906 14.506 17.5907 14.8235 17.442 15.0813C17.2934 15.3391 17.0185 15.498 16.721 15.4983H16.7218ZM8.16681 11.3317V12.9983H8.94431H8.99848H9.05265H9.83181V11.3317H8.16681ZM8.16681 5.49833V9.665H9.83348V5.49833H8.16681Z",
    fill: "#EDCB74"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAmber);
export default __webpack_public_path__ + "static/media/warning_amber.f385bacfb6812da01a1c43b7f6588acf.svg";
export { ForwardRef as ReactComponent };